import './chunk-1fafdf15.js';
import './helpers.js';
import './chunk-ce068f0a.js';
import './chunk-1f2cfc27.js';
import './chunk-4139443a.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { S as Select } from './chunk-3b7f7d0b.js';
export { S as BSelect } from './chunk-3b7f7d0b.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Select);
  }
};
use(Plugin);

export default Plugin;
